export default {
      id: "menu__user-profile-usage",
      viewBox: "0 0 18 16",
      url: __webpack_public_path__ + "img/icons.svg#menu__user-profile",
      toString: function () {
        return this.url;
      }
    }